import { render, staticRenderFns } from "./veStuMoralActive.vue?vue&type=template&id=4d2ff4f4&scoped=true"
import script from "./veStuMoralActive.vue?vue&type=script&lang=js"
export * from "./veStuMoralActive.vue?vue&type=script&lang=js"
import style0 from "./veStuMoralActive.vue?vue&type=style&index=0&id=4d2ff4f4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2ff4f4",
  null
  
)

export default component.exports